























































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Actions, Mutations, FormModes } from '@/ts/store/Constants';
import InlineImages from '@/components/Gallery/InlineImages.vue';
import TextfieldEditor from '@/components/TextfieldEditor.vue';
import Recipients from '@/components/Selects/Recipients.vue';
import RecipientMethods from '@/mixins/RecipientMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    components: {
        InlineImages,
        TextfieldEditor,
        Recipients,
        DatePicker,
    },
})
export default class BroadcastForm extends Mixins(InputFieldMethods, RecipientMethods, LocalizationMethods, DateMethods) {
    @Prop({ default: 'create' }) public mode: string;

    public communicationChannel: string = 'note';
    public sessionUUID: string = null;
    public broadcastMainImage: File|null = null;
    public mainImagePreview: string|null = null;
    public attachedImageWasDeleted: boolean = false;

    public hasRecipientsError: boolean = false;

    get isEditing(): boolean {
        return this.mode === FormModes.Edit;
    }

    get isCreating(): boolean {
        return this.mode === FormModes.Create;
    }

    get showEventScheduling(): boolean {
        return this.isCreating || (
            this.isEditing && this.activeNotification.publishedAt !== null && !this.activeNotification.queueIsExecuted
        );
    }

    get notificationRecipients(): string {
        return this.$store.getters['Notifications/getNotificationRecipients'];
    }

    get media() {
        return this.$store.getters['Notifications/getActiveNotificationMedia'];
    }

    get activeNotification() {
        return this.$store.getters['Notifications/getActiveNotification'];
    }

    get mainImage() {
        if (this.isEditing && this.media && !this.attachedImageWasDeleted) {
            return this.media.base64;
        }

        if (this.mainImagePreview) {
            return this.mainImagePreview;
        }

        return null;
    }

    get title(): string {
        return this.$store.getters['Notifications/getNotificationTitle'];
    }

    set title(value: string) {
        this.$store.commit(Mutations.UPDATE_NOTIFICATION_TITLE, value);
    }

    get description(): string {
        return this.$store.getters['Notifications/getNotificationDescription'];
    }

    set description(value: string) {
        this.$store.commit(Mutations.UPDATE_NOTIFICATION_DESCRIPTION, value);
    }

    get notificationPublishedAt(): any {
        return this.$store.getters['Notifications/getNotificationPublishedAt'];
    }

    set notificationPublishedAt(value: any) {
        this.$store.commit(Mutations.UPDATE_NOTIFICATION_PUBLISHED_AT, value);
    }

    get schedulingMinDate() {
        return this.getCurrentLocalTimeStamp();
    }

    get corporation() {
        return this.$store.getters['Corporations/getCorporation'](this.$store.getters['User/getCorporationId']);
    }

    @Watch('broadcastMainImage')
    public broadcastMainImageChanged() {
        if (this.broadcastMainImage !== null) {
            const reader = new FileReader();
            reader.readAsDataURL(this.broadcastMainImage);

            reader.onload = (e: any) => {
                this.mainImagePreview = e.target.result;
            };

            return;
        }

        this.mainImagePreview = null;
    }

    @Watch('selectedRecipientsWithActionTargets')
    public recipientsChanged() {
        this.hasRecipientsError = false;
    }

    public deleteImage() {
        this.attachedImageWasDeleted ? this.removeImage() : this.markAttachedImageAsDeleted();
    }

    public removeImage() {
        const element = (this.$refs.broadcastMainPhoto as HTMLInputElement);

        this.broadcastMainImage = null;
        this.mainImagePreview = null;

        element.type = 'text';
        element.type = 'file';
    }

    public markAttachedImageAsDeleted() {
        this.attachedImageWasDeleted = true;
    }

    public setDescription(message: any): void {
        this.description = message;
    }

    public addImagesSessions(sessionUUID: string) {
        this.sessionUUID = sessionUUID;
    }

    public addBroadcastImage() {
        this.markAttachedImageAsDeleted();

        const element = (this.$refs.broadcastMainPhoto as HTMLInputElement);
        this.broadcastMainImage = element.files.length === 0 ? null : (element.files[0] as File);

        if (element.files.length === 0 ) {
            element.type = 'text';
            element.type = 'file';
        }
    }

    public fetchNotificationMedia() {
        if (this.isEditing && this.activeNotification.hasMedia) {
            this.$store.dispatch(Actions.FETCH_NOTIFICATION_MEDIA, this.activeNotification.id);
        }
    }

    public create() {
        this.hasRecipientsError = !this.hasRecipients(this.selectedRecipientsWithActionTargets, true);

        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.HIDE_FORM);

                if (this.hasRecipientsError) {
                    return;
                }

                this.$store.dispatch(Actions.POST_NOTIFICATIONS, {
                    channel: this.communicationChannel,
                    recipients: this.recipientsIds,
                    sessionUUID: this.sessionUUID,
                    mainImage: this.broadcastMainImage,
                });

                this.resetRecipients();
            }
        });
    }

    public update() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.commit(Mutations.HIDE_EDIT_NOTIFICATION_FORM);

                this.$store.dispatch(Actions.EDIT_NOTIFICATION, {
                    sessionUUID: this.sessionUUID,
                    mainImage: this.broadcastMainImage,
                    mainImageRemoved: this.attachedImageWasDeleted,
                });

                this.resetRecipients();
            }
        });
    }

    public close(): void {
        this.$store.commit(Mutations.SET_ACTIVE_NOTIFICATION_MEDIA, null);
        this.resetRecipients();

        if (this.isEditing) {
            this.$store.commit(Mutations.HIDE_EDIT_NOTIFICATION_FORM);
            return;
        }

        this.$store.dispatch(Actions.HIDE_FORM);

        this.title       = '';
        this.description = '';

        this.$nextTick(() => {
            this.errors.clear();
            this.$validator.reset();
        });
    }

    public created() {
        this.fetchNotificationMedia();
    }
}
